import {Action, createReducer, on} from '@ngrx/store';
import {EmployeeState} from './employee.model';
import {employeeReset, employeeSave} from './employee.action';

export const initialState: EmployeeState = {
    userId: '',
    id: '',
    employeeCode: ''
};

const reducer = createReducer(
    initialState,
    on(employeeSave, (state, props) => ({
        ...state,
        userId: props.employeeState.userId,
        id: props.employeeState.id,
        employeeCode: props.employeeState.employeeCode
    })),
    on(employeeReset, (state) => ({
        ...state,
        userId: '',
        id: '',
        employeeCode: ''
    }))
);

export function employeeReducer(
    state: EmployeeState | undefined,
    action: Action
): EmployeeState {
    return reducer(state, action);
}
